// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h5[data-v-20c9bccd]{font-size:1.1rem}.modal-scrollable-content[data-v-20c9bccd]{max-height:calc(85vh - 160px);overflow-y:auto}", ""]);
// Exports
module.exports = exports;
